/* eslint-disable @typescript-eslint/naming-convention */

/* eslint-disable no-shadow */
export enum Loading {
  Idle = 'IDLE',
  Pending = 'PENDING',
  Resolved = 'RESOLVED',
  Rejected = 'REJECTED'
}
